import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import DeleteItemModalWrapper from '../../components/Modals/DeleteItemModalWrapper'
import DeleteItemModal from '../../components/Modals/DeleteItemModal'
import useDeleteAction from './index'

import { clearCampaign, clearDeleteCampaign, deleteCampaign, getCampaign } from '../../../modules/actions/campaigns'
import {
  campaignDeleteErrorSelector,
  campaignDeleteIsLoadingSelector,
  campaignDeleteItemSelector,
  campaignSelector,
  campaignWasLoadedSelector
} from '../../../modules/selectors/campaigns'

export const useDeleteCampaignAction = ({ updateCombinedCampaignsList = false } = {}) => {
  const dispatch = useDispatch()

  const campaignWasLoaded = useSelector(campaignWasLoadedSelector)
  const campaign = useSelector(campaignSelector)

  const deleteCampaignHandler = useCallback(
    params => {
      dispatch(
        deleteCampaign(params, {
          updateCombinedCampaignsList
        })
      )
    },
    [dispatch, updateCombinedCampaignsList]
  )

  const clearDeleteCampaignHandler = useCallback(() => {
    dispatch(clearDeleteCampaign())
  }, [dispatch])

  const {
    handleDelete,
    handleDeleteRequest,
    handleCloseDeleteModal,
    isDeleteModalOpened,
    deleteItemIsLoading,
    dataWaitingForDelete
  } = useDeleteAction({
    onDelete: deleteCampaignHandler,
    onClearDelete: clearDeleteCampaignHandler,
    deletedItemSelector: campaignDeleteItemSelector,
    deleteItemErrorSelector: campaignDeleteErrorSelector,
    deleteItemIsLoadingSelector: campaignDeleteIsLoadingSelector
  })

  const getListItemHandler = useCallback(() => {
    const { item = {}, platform: selectedPlatform = '', account: selectedAdAccountId = '' } = dataWaitingForDelete
    const { id: campaignId } = item

    dispatch(
      getCampaign(
        {
          return_impressions: true, // todo PBR-1221 check if this param works when BE done
          id: campaignId,
          account: selectedAdAccountId
        },
        selectedPlatform
      )
    )
  }, [dispatch, dataWaitingForDelete])

  const clearHandler = useCallback(() => {
    dispatch(clearCampaign())
  }, [dispatch])

  return useMemo(() => {
    return {
      handleDeleteRequest,
      DeleteCampaignModal: (
        <DeleteItemModalWrapper
          isDeleteModalOpened={isDeleteModalOpened}
          handleCloseDeleteModal={handleCloseDeleteModal}
          dataWaitingForDelete={dataWaitingForDelete}
          getListItemHandler={getListItemHandler}
          clearHandler={clearHandler}
          itemWasLoaded={campaignWasLoaded}
          loadedItem={campaign}
        >
          <DeleteItemModal
            handleDelete={handleDelete}
            handleCloseDeleteModal={handleCloseDeleteModal}
            isDeleteModalOpened={isDeleteModalOpened}
            deleteItemIsLoading={deleteItemIsLoading}
            deleteModalMessage="This cannot be undone."

            // todo archive button is commented, but may be be needed in future
            // props for archive button
            // archiveProps={{
            //   updateItemAction: updateCampaign,
            //   updatedItemSelector: campaignUpdateSelector,
            //   updateItemErrorSelector: campaignUpdateErrorSelector,
            //   updateItemIsLoadingSelector: campaignUpdateIsLoadingSelector,
            //   clearUpdateAction: clearUpdateCampaign,
            //   dataWaitingForDelete
            // }}
          />
        </DeleteItemModalWrapper>
      )
    }
  }, [
    handleDeleteRequest,
    isDeleteModalOpened,
    handleCloseDeleteModal,
    dataWaitingForDelete,
    handleDelete,
    deleteItemIsLoading,
    getListItemHandler,
    clearHandler,
    campaignWasLoaded,
    campaign
  ])
}
